<svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <polygon id="Path-3" fill-rule="evenodd" points="14 8 14 10 4 10 4 8" />
</svg>